<template>
  <div class="header">
    <div class="section-header flex-row justify-between">
      <div class="logo">
        <router-link to="/"
          ><img src="../assets/images/logo.png" width="200" height="85"
        /></router-link>
      </div>
      <div class="menu flex-col justify-end">
        <div class="flex-row justify-end topnav">
          <a href="http://engedu.ikcest.org/unesco/" target="_blank">EEKS</a>
          <a href="http://mooc.engedu.ikcest.org/" target="_blank">MOOC</a>
          <a
            href="http://www.icee-unesco.org/unesco/certification/"
            target="_blank"
            >Training Workshop</a
          >
        </div>
        <ul class="flex-row justify-between nav">
          <li>
            <router-link to="/">Home</router-link>
          </li>
          <li>
            <router-link
              to="/news"
              :class="{ 'router-link-exact-active': active('/news') }"
              >News</router-link
            >
          </li>
          <li>
            <router-link
              to="/research"
              :class="{ 'router-link-exact-active': active('/research') }"
              >Research</router-link
            >
          </li>
          <li>
            <router-link
              to="/events"
              :class="{ 'router-link-exact-active': active('/events') }"
              >Events</router-link
            >
          </li>
          <li>
            <router-link
              to="/videos"
              :class="{ 'router-link-exact-active': active('/videos') }"
              >Videos</router-link
            >
          </li>
          <li>
            <router-link to="/partnership">Partnership</router-link>
          </li>
          <li>
            <router-link to="/about-us">About Us</router-link>
          </li>
          <li>
            <router-link to="/contact">Contact</router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";
import { useActiveLink } from "../hooks/link-active";
export default defineComponent({
  components: {},
  name: "Header",
  setup(props, ctx) {
    const { active } = useActiveLink(ctx);
    return {
      active,
    };
  },
});
</script>
<style lang="scss" scoped>
.header {
  .section-header {
    width: 1160px;
    margin: 0 auto;
  }
  border-bottom: 2px solid #1c7fbb;
  .logo {
    width: 200px;
    height: 85px;
    margin: 13px 0 13px 0;
  }
  .menu {
    flex: 0 0 920px;
    height: 94px;
    margin-top: 10px;
    .topnav {
      margin-bottom: 6px;
      a {
        padding-left: 64px;
        color: #b1a9a7;
        line-height: 20px;
        font-size: 14px;
        font-weight: 400;
        &:hover {
          color: #0364ff;
        }
      }
    }
    .nav {
      margin-top: 20px;
      a {
        font-weight: 600;
        color: #231916;
        line-height: 22px;
        &.router-link-exact-active {
          color: #1c7fbb;
        }
        &:hover {
          color: #0364ff;
        }
      }
    }
  }
}
</style>
